import { render, staticRenderFns } from "./BidirectionalExpandable.vue?vue&type=template&id=1b1469e0&"
import script from "./BidirectionalExpandable.vue?vue&type=script&lang=js&"
export * from "./BidirectionalExpandable.vue?vue&type=script&lang=js&"
import style0 from "./BidirectionalExpandable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports